import {useState} from "react";
import {Button} from "../../../../basic-ui-components/button/base/button.component";
import {Select} from "../../../../basic-ui-components/form/select.component";
import {Magic8BallAnimationComponent} from "../../../magic-8-ball-animation/magic-8-ball-animation.component";

const magic8BallPrizes = ["$1", "888 free spins", "$3", "5 free play", "10 bonus"];

export const Magic8BallShowcase: React.FC = () => {
    let [showIntent, setShowIntent] = useState(false);
    let [prizeWonIndex, setPrizeWonIndex] = useState(0);

    return <>
        <Button preset="primary" onClick={() => {
            setShowIntent(true);
        }}>Magic 8 ball</Button>
        <Select
                name={"magic_ball_prize"}
                id={"magic_ball_prize"}
                value={prizeWonIndex}
                onChange={(e) => {
                    const rawValue = e.target.options[e.target.selectedIndex].value;
                    const theValue = rawValue === "random" ? null : parseInt(rawValue);
                    setPrizeWonIndex (theValue);
                }}
                width="150px"
            >
                {magic8BallPrizes.map((p, idx) =>
                    <option key={idx} value={idx}>{p}</option>
                )}
                <option key={"random"} value={"random"}>Random</option>
        </Select>
        <Magic8BallAnimationComponent
            showIntent={showIntent}
            prizes={magic8BallPrizes}
            prizeWonIndex={prizeWonIndex === null ? Math.floor(Math.random() * magic8BallPrizes.length) : prizeWonIndex}
            onClose={() => {
                setShowIntent(false);
            }}
        />
        {/* <div>
            {isShown ? "Magic 8 Ball Shown" : showIntent ? "Magic 8 Ball LOADING" : "Click the button"}
        </div> */}
    </>;
}